export default __webpack_public_path__ + "static/media/icon-arrow-triangle-up.8d856f9c.svg";